import callAPiBase from './base';

const deviceApi = {
  deviceStatus: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/deviceStatus',
      method: 'GET',
      useToken: true,
      title: 'Device - Status',
      params,
    }),
  deviceStatusList: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/deviceStatusList',
      method: 'GET',
      useToken: true,
      title: 'Device - Status List',
      params,
    }),
  deviceTimeline: ({ params }: { params: { deviceId: string } }) =>
    callAPiBase({
      endpoint: '/deviceTimeline',
      method: 'GET',
      useToken: true,
      title: 'Device - Timeline',
      params,
    }),
  devicesAppVersionList: ({ params }: { params: { transportOperatorId: string; appType: string } }) =>
    callAPiBase({
      endpoint: '/devicesByVersion',
      method: 'GET',
      useToken: true,
      title: 'Device - App Version List',
      params,
    }),
};

export { deviceApi };
export default deviceApi;
